import { detect } from 'detect-browser';
const browser = detect();

import debounce from 'lodash/debounce';

export default {
    data: () => ({
        W: {
            w: window.innerWidth,
            h: window.innerHeight,
        },
        isHorizontal: false,
        horizontalBreakpoint: null,
        browser: null
    }),
    created() {

        // Define browser vars
        this.browser = {
            name: browser.name,
            oser: browser.os,
        };

        // Get horizontal breakpoint from css
        this.horizontalBreakpoint = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-horizontal')
    },
    mounted() {

        const set = () => {
            // Define window vars
            this.W = {
                w: window.innerWidth,
                h: window.innerHeight,
            }

            // Check mediaquery for horizontal layout
            if(window.matchMedia(this.horizontalBreakpoint).matches) {
                this.isHorizontal = true
            } else {
                this.isHorizontal = false
            }
        }

        // Set size
        set()

        // Window events
        window.addEventListener('resize', debounce(set, 100));
    },
    methods: {
        ifHorizontal(val1, val2) {
            return this.isHorizontal ? val1 : val2;
        }
    },
}
